// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"52":"48a1a44a","995":"e5524c22"}[chunkId] + ".chunk.css");